import { RECEIVE_POINT, RECEIVE_POINT_KEY_FIGURES, RECEIVE_POINT_NETWORKS, RECEIVE_SAMPLING_SURFACE_POINT, RESET_POINT_INFORMATIONS } from '../constants/PointConstants'
import DtoPoint from '../dto/DtoPoint'
import DtoKeyFigures from '../../sites/dto/DtoKeyFigures'
import DtoNetwork from '../dto/DtoNetwork'
import DtoSamplingSurfacePoint from '../dto/DtoSamplingSurfacePoint'

export const store = {
	point: undefined,
	pointKeyFigures: [],
	pointNetworks: [],
	samplingSurfacePoints: []
}

export function PointReducer(state = {}, action) {
	switch (action.type) {
		case RECEIVE_POINT: {
			return Object.assign({}, state, {
				point: new DtoPoint(action.point)
			})
		}
		case RECEIVE_POINT_KEY_FIGURES: {
			return Object.assign({}, state, {
				pointKeyFigures: action.pointKeyFigures.map(o => new DtoKeyFigures(o))
			})
		}
		case RECEIVE_POINT_NETWORKS: {
			return Object.assign({}, state, {
				pointNetworks: action.pointNetworks.map(o => new DtoNetwork(o))
			})
		}
		case RECEIVE_SAMPLING_SURFACE_POINT: {
			return Object.assign({}, state, {
				samplingSurfacePoints: action.samplingSurfacePoints.map(o => new DtoSamplingSurfacePoint(o))
			})
		}
		case RESET_POINT_INFORMATIONS: {
			return Object.assign({}, state, store)
		}
		default:
			return state
	}
}




// WEBPACK FOOTER //
// ./src/point/reducers/PointReducer.js